export default "__VITE_ASSET__uxXI9ZvY__"